<label class="hint">
  <span>
    <svg-icon *ngIf="icon" [name]="icon" [size]="13"></svg-icon>
    <span class="truncate">{{ text }}</span>
  </span>
</label>
